<template>
  <div class="overflow-auto mt-4">
    <div v-if="totalItem > 0" style="float: left;" class="mt-1 pb-5">
      <span>{{ $t('common.totalVoucher', { num: totalItem }) }}</span>
    </div>
    <div style="float: right;">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        last-number
        @input="onPageChange"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      rows: {
        type: Number,
        default: () => {
          return 1
        }
      },
      perPage: {
        type: Number,
        default: () => {
          return 1
        }
      },
      currentPage: {
        type: Number,
        default: () => {
          return 1
        }
      },
      totalItem: {
        type: Number,
        default: () => {
          return 0
        }
      }
    },
    methods: {
      onPageChange: function () {
        this.$emit('onPageChange', this.currentPage)
      }
    }
  }
</script>
<style lang="scss" scoped>
@import "../styles/color.scss";
:deep(.page-item .page-link) {
    color: $primary;
    border-radius: 50%;
    margin-right: 5px;
}
:deep(.pagination .page-item:last-child .page-link) {
    margin-right: 0px;
}
:deep(.page-item.active .page-link) {
    background: $btn-background;
    border-radius: 50%;
    color: white !important;
}
</style>